"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = Flag;

var _propTypes = require("prop-types");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

Flag.propTypes = {
  style: _propTypes.object,
  size: _propTypes.number,
  alt: _propTypes.string.isRequired,
  src: _propTypes.string.isRequired
};
Flag.defaultProps = {
  size: 24,
  style: {}
};

var getStyles = function getStyles(size) {
  return {
    width: size + "px",
    height: size + "px",
    display: "inline-block"
  };
};

function Flag(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  var style = getStyles(size);
  return _react2.default.createElement("img", _extends({}, props, {
    style: _extends({}, style, props.style),
    alt: props.alt
  }));
}